import React from 'react';
import { Link } from 'react-router-dom';
import { useProjectsController } from '../controllers/ProjectsController';
import ProjectsShimmer from '../views/components/ProjectShimmer';
import SectionWrapper from '../views/components/SectionWrapper';
import { useLanguage } from '../i18n/LanguageContext';

export default function ProjectsView() {
  const { t } = useLanguage();
  const { data, loading, error } = useProjectsController();

  if (loading) return <ProjectsShimmer />;
  if (error) return <div className="alert alert-danger">{t('errors.projects')}</div>;

  return (
    <SectionWrapper id="projects">
      <div className="text-center mb-5" data-aos="fade-up">
        <h2 className="section-title">
          {t('projects.titlePrefix')} <span className="highlight">{t('projects.titleHighlight')}</span>
        </h2>
        <p className="section-subtitle">
          {t('projects.subtitle')}
        </p>
      </div>

      <div className="row">
        {data.map((project, i) => (
          <div
            key={project.id}
            className="col-sm-6 col-md-4 mb-4"
            data-aos="fade-up"
            data-aos-delay={i * 100}
          >
            <div className="project-card h-100 d-flex flex-column">
              <img
                src={project.image}
                alt={project.name}
                className="project-img"
              />
              <div className="p-4 flex-grow-1 d-flex flex-column">
                <h5 className="project-title">{project.name}</h5>
                <p className="project-description flex-grow-1">
                  {project.description}
                </p>
                <Link
                  to={`/projects/${project.id}`}
                  className="btn btn-outline-accent align-self-start mt-3"
                >
                  {t('projects.viewProject')}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
